export type TMode = {
  type?: string;
  color: string;
  icon: string;
};

type ModeKeys = 'success' | 'processing' | 'info' | 'error' | 'warning' | 'unknown' | 'disabled';

export type TModes = Record<string, never> | Record<ModeKeys, TMode>;

export const modes: TModes = {
  success: {
    color: 'success',
    icon: 'successCheck',
  },
  processing: {
    color: 'accent',
    icon: 'pending',
  },
  info: {
    color: 'accent',
    icon: 'info',
  },
  error: {
    color: 'simpleWhite',
    icon: 'error',
  },
  warning: {
    color: 'simpleWhite',
    icon: 'info',
  },
  unknown: {
    color: 'simpleWhite',
    icon: 'question',
  },
  disabled: {
    color: 'simpleWhite',
    icon: 'info',
  },
};
